import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from "vue2-google-maps";
import './styles/style.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlay, faPause, faCompass, faVolumeUp, faCalendarAlt} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlay, faPause, faCompass, faVolumeUp, faCalendarAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false



Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCGhu1F4W-9no_loG1NMvAPJgI7FMyU6RM',
    libraries: 'places'
  }
});

window.App = new Vue({
  el: '#app',
  components: { App },
  template: "<App/>"
})
